<template>
  <div class="grid-view">
    <div class="main-content">
      <div class="section operations">
        <div class="triggers">
          <div>
            <el-button v-if="!isEdit" type="primary" @click="editCustomEvent">{{ $t('SystemMaintenance.Edit') }}</el-button>
            <el-button v-if="!isEdit" type="danger" @click="delRuleEvent">{{ $t('SystemMaintenance.DeleteConfiguration') }}</el-button>
            <el-button v-if="isEdit" type="primary" @click="saveCustomEvent">{{ $t('SystemMaintenance.Save') }}</el-button>
            <el-button v-if="isEdit" type="default" @click="cancelCustomEvent">{{ $t('SystemMaintenance.Cancel') }}</el-button>
            <el-button no="onDownloadTemplate" type="primary" @click="onDownloadTemplate()">{{ $t('SeaExport.DownloadPortServiceScope') }}</el-button>
          </div>
        </div>
      </div>
      <div class="form-column">
        <span class="title">{{ $t('SystemMaintenance.PushCondition') }}<i class="el-icon-question" :title="$t('SystemMaintenance.DataCargoTrackingPurchaseEffect')" /></span>
        <el-form label-width="100px" label-position="left" :disabled="!isEdit">
          <el-form-item :label="$t('SystemMaintenance.PushFCLLCLType')">
            <cargo-advance-select
              ref="containerLoadType"
              :clearable="false"
              multiple
              :default-multiple-value="containerLoadTypes"
              :static-options="containerLoadTypesList"
              tag-value="code"
              style="width:300px"
              :placeholder="isEdit ? $t('SystemMaintenance.PleaseSelectFCLLCLType') : ' '"
              @parentCallBack="p=>{cargoTypeChange(p)}"
            />
          </el-form-item>

        </el-form>
        <div class="form-config-more">
          <el-form label-width="100px" label-position="left" :disabled="!isEdit">
            <el-form-item :label="$t('SystemMaintenance.DoServicesNeedToVoyage')" label-width="300px">
              <el-radio-group v-model="form.vesselVoyage">
                <el-radio label="1">{{ $t('SystemMaintenance.Yes') }}</el-radio>
                <el-radio label="0">{{ $t('SystemMaintenance.No') }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>

          <el-checkbox-group v-model="loadingPortCodesList" :disabled="!isEdit">
            <label style="width:150px;">{{ $t('SystemMaintenance.PortPortOfDepartureRange') }}</label>
            <el-checkbox label="CNSHA">{{ $t('SystemMaintenance.Shanghai') }}</el-checkbox>
            <el-checkbox label="CNNGB">{{ $t('SystemMaintenance.Ningbo') }}</el-checkbox>
            <el-checkbox label="CNXMN">{{ $t('SystemMaintenance.Xiamen') }}</el-checkbox>
            <el-checkbox label="CNSZX">{{ $t('SystemMaintenance.Shenzhen') }}</el-checkbox>
            <!-- <el-checkbox label="CNYTN">盐田</el-checkbox>
            <el-checkbox label="CNSHK">蛇口</el-checkbox>
            <el-checkbox label="CNDCB">大铲湾</el-checkbox> -->
            <el-checkbox label="CNNSA">{{ $t('SystemMaintenance.NanSha') }}</el-checkbox>
            <el-checkbox label="CNTAO">{{ $t('SystemMaintenance.Qingdao') }}</el-checkbox>
            <el-checkbox label="CNTXG">{{ $t('SystemMaintenance.Tianjin') }}</el-checkbox>
            <!--<el-checkbox label="CNDLC">{{ $t('SystemMaintenance.Dalian') }}</el-checkbox>-->
          </el-checkbox-group>

          <el-form label-position="left" :disabled="!isEdit">
            <el-form-item :label="$t('SystemMaintenance.IsTrackingLimitedToDeparture')" label-width="200px">
              <el-radio-group v-model="form.trackingLoadingPort">
                <el-radio :label="1">{{ $t('SystemMaintenance.Yes') }}</el-radio>
                <el-radio :label="0">{{ $t('SystemMaintenance.No') }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
          <span class="title">{{ $t('SystemMaintenance.DataSettings') }}</span>
          <span>{{ $t('SystemMaintenance.SynchronizationLogicSettings') }}</span>
          <el-checkbox-group v-model="synchronizationLogicSettingList" :disabled="!isEdit">
            <el-checkbox label="0" class="sync-checkbox" style="display: block;">{{ $t('SystemMaintenance.unBerthPlanDateSynETD') }}</el-checkbox>
            <el-checkbox label="1" class="sync-checkbox" style="display: block;">{{ $t('SystemMaintenance.estimatedArrivalTimeSynETA') }}</el-checkbox>
          </el-checkbox-group>
          <span class="title">{{ $t('SystemMaintenance.ClearSettings') }}</span>
          <el-checkbox v-model="form.cleanPolPortInfo" style="margin-left: 20px;" :disabled="!isEdit" @change="handleCheckboxChange">{{ $t('SystemMaintenance.ClearVoyageAndShipPeriodData') }}</el-checkbox>
          <span class="title">{{ $t('SystemMaintenance.SubscriptionScope') }}</span>
          <el-tabs v-model="activeTabName">
            <el-tab-pane :label="$t('SystemMaintenance.Consignor')" name="consignor">
              <br>
              <el-form label-width="100px" label-position="left" :disabled="!isEdit">
                <el-form-item>
                  <template slot="label">
                    <label style="font-weight: normal">{{ $t('SystemMaintenance.ConditionType') }}<i class="el-icon-question" :title="$t('SystemMaintenance.SelectServiceEnabledSelectEffect')" /></label>
                  </template>
                  <el-select v-model="form.pushCondition" style="width: 200px" @change="handleChange">
                    <el-option :label="$t('SystemMaintenance.All')" :value="1" />
                    <el-option :label="$t('SystemMaintenance.WhiteList')" :value="2" />
                    <el-option :label="$t('SystemMaintenance.BlackList')" :value="3" />
                  </el-select>
                </el-form-item>
              </el-form>
            </el-tab-pane>
            <el-tab-pane :label="$t('SystemMaintenance.BookingAgent')" name="bookingAgent">
              <br>
              <el-form label-width="100px" label-position="left" :disabled="!isEdit">
                <el-form-item>
                  <template slot="label">
                    <label style="font-weight: normal">{{ $t('SystemMaintenance.ConditionType') }}<i class="el-icon-question" :title="$t('SystemMaintenance.SelectServiceEnabledSelectEffect')" /></label>
                  </template>
                  <el-select v-model="form.pushConditionBa" style="width: 200px" @change="handleChange">
                    <el-option :label="$t('SystemMaintenance.All')" :value="1" />
                    <el-option :label="$t('SystemMaintenance.WhiteList')" :value="2" />
                    <el-option :label="$t('SystemMaintenance.BlackList')" :value="3" />
                  </el-select>
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div v-show="((form.pushCondition !== 1 && activeTabName === 'consignor') || (form.pushConditionBa !== 1 && activeTabName === 'bookingAgent'))" class="grid-wrapper">
        <div class="screen-btn">
          <el-button :disabled="!isEdit" type="primary" @click="addCustomerEvent">{{ $t('SystemMaintenance.Add') }}</el-button>
          <el-button :disabled="!isEdit" type="danger" @click="delCustomEvent">{{ $t('SystemMaintenance.Delete') }}</el-button>
        </div>
        <cargo-ag-grid
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          @gridReady="params=>{gridApi=params.api;gridApi.sizeColumnsToFit()}"
        />
      </div>
      <div class="grid-wrapper">
        <span class="title">{{ $t('SystemMaintenance.CloseOpen') }}</span>
        <div class="screen-btn">
          <el-button :disabled="!isEdit" type="primary" @click="addBranch">{{ $t('SystemMaintenance.Add') }}</el-button>
          <el-button :disabled="!isEdit" type="danger" @click="delBranch">{{ $t('SystemMaintenance.Delete') }}</el-button>
        </div>
        <cargo-ag-grid
          :grid-options="gridOptions2"
          :column-defs="columnDefs2"
          :row-data="rowData2"
          @gridReady="params=>{gridApi2=params.api;gridApi2.sizeColumnsToFit()}"
        />
      </div>
    </div>

    <!-- 新增客户弹框 -->
    <subscribe-port-push-rule-customer-dialog
      :title="title"
      :visible.sync="ruleViewVisible"
      :customers="portDataSubscribeConfigCompanyList"
      @saveCallBack="saveCallBackFunc"
      @close="ruleViewVisible=false"
    />
  </div>
</template>

<script>
import CommonState from '@/class/cargo/model/parameters/CommonState'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import * as subscribePortPushRuleApi from '@/api/sysManage/subscribePortPushRule'
import SubscribePortPushRuleCustomerDialog from '@/views/cargo/v0/SystemMaintenance/components/SubscribePortPushRuleCustomerDialog'
import { getGridSelected } from '@/utils/agGrid'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import lodash from 'lodash'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { UN_BERTH_PLAN_DATE } from '@/class/cargo/model/parameters/SystemConstants'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'SubscribePortPushRuleView',
  components: { SubscribePortPushRuleCustomerDialog, cargoAdvanceSelect },
  data() {
    return {
      isEdit: false,
      propertyDownlist: [],
      containerLoadTypesList: ContainerLoadType.CONTAINERLOAD_TYPES,
      loadingPortCodesList: [],
      containerLoadTypes: [],
      portDataSubscribeConfigCompanyList: [],
      officeAll: [],
      form: {
        containerLoadType: '', // 推送整拼类型
        vesselVoyage: '', // 是否更新船名航次
        loadingPortCodes: '', // 起运港
        pushCondition: 1, // 推送条件
        pushConditionBa: 1, // 订舱代理推送条件
        portDataSubscribeConfigCompanyList: [], // 合作伙伴列表
        propertyType: 'OMS_JOB.CUSTOMER_ID',
        synchronizationLogicSettings: '',
        cleanPolPortInfo: false,
        trackingLoadingPort: 1
      },
      gridApi: null,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      gridApi2: null,
      gridOptions2: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        frameworkComponents: {
          CargoAgGridSelectEditor
        }
      },
      rowData: [],
      rowData2: [],
      PROPERTY_CUSTOMER_ID: null,
      pushRules: [],
      ruleViewVisible: false,
      title: '',
      loadingPortCodes: [],
      synchronizationLogicSettingList: [],
      activeTabName: 'consignor'
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          pinned: 'left',
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.activeTabName === 'consignor' ? this.$t('CargoMsg.Cargo_CustomerName') : this.$t('SystemMaintenance.BookingAgent'),
          field: 'chineseName',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BranchCMP'),
          field: 'branchId',
          width: 200,
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'code')
          }
        }
      ]
    },
    columnDefs2() {
      return [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          pinned: 'left',
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BranchCMP'),
          field: 'branchId',
          cellEditor: 'CargoAgGridSelectEditor',
          width: 200,
          editable: this.isEdit,
          cellEditorParams: {
            selectProps: {
              filterable: true
            },
            options: this.officeAll,
            tagName: 'chineseName',
            tagValue: 'officeId'
          },
          cellRenderer: (params) => {
            if (!params.value) return ''
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'chineseName')
          }
        }
      ]
    }
  },
  watch: {
    activeTabName(newVal, oldVal) {
      this.applyFilter()
    }
  },
  created() {
    this.PROPERTY_CUSTOMER_ID = new CommonState('OMS_JOB.CUSTOMER_ID', '委托单位', 'OMS_JOB.CUSTOMER_ID')
    this.propertyDownlist.push(this.PROPERTY_CUSTOMER_ID)
    this.initData()
  },
  methods: {
    // 初始化数据
    async initData() {
      this.officeAll = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
      subscribePortPushRuleApi.querySubscribeConfig({}).then(res => {
        if (res.data.length > 0) {
          this.form = res.data[0]
          if (this.form.loadingPortCodes) {
            this.loadingPortCodesList = this.form.loadingPortCodes.split(',')
          } else {
            this.loadingPortCodesList = []
          }
          if (this.form.synchronizationLogicSettings) {
            this.synchronizationLogicSettingList = this.form.synchronizationLogicSettings.split(',')
          } else {
            this.synchronizationLogicSettingList = []
          }
          if (this.form.containerLoadType) {
            this.containerLoadTypes = this.form.containerLoadType.split(',')
            this.$refs.containerLoadType.convertSelectedToText()
          } else {
            this.containerLoadTypes = []
          }
          if (this.form.pushCondition === 2 || this.form.pushCondition === 3 || this.form.pushConditionBa === 2 || this.form.pushConditionBa === 3) {
            this.portDataSubscribeConfigCompanyList = lodash.cloneDeep(this.form.portDataSubscribeConfigCompanyList)
            this.portDataSubscribeConfigCompanyList.forEach(eve => {
              eve.chineseName = eve.cmpName
            })
            this.form.portDataSubscribeConfigCompanyList.forEach(eve => {
              eve.chineseName = eve.cmpName
              eve.actionType = 0
            })
            this.sortCmp()
          }
          if (this.form.closeOffice) {
            const intList = this.form.closeOffice.split(',').map(Number)
            if (intList) {
              this.rowData2 = intList.map(num => ({ branchId: num }))
            }
          }
          this.form.propertyType = 'OMS_JOB.CUSTOMER_ID'
        } else {
          this.form.uuid = undefined
          this.form.version = undefined
          this.form.containerLoadType = ''
          this.form.vesselVoyage = '1'
          this.form.trackingLoadingPort = 1
          this.form.loadingPortCodes = ''
          this.form.pushCondition = 1
          this.form.pushConditionBa = 1
          this.form.portDataSubscribeConfigCompanyList = []
          this.form.propertyType = 'OMS_JOB.CUSTOMER_ID'
          this.portDataSubscribeConfigCompanyList = []
          this.containerLoadTypesList = ContainerLoadType.CONTAINERLOAD_TYPES
          this.loadingPortCodesList = []
          this.synchronizationLogicSettingList = []
          this.form.cleanPolPortInfo = false
          this.containerLoadTypes = []
        }
      })
    },
    getCommonStateByCode(code, arrs) {
      let foundObj = null
      for (const obj of arrs) {
        if (obj.code === code) {
          foundObj = obj
          break
        }
      }
      return foundObj
    },
    sortCmp() {
      this.applyFilter()
    },
    editCustomEvent() {
      if (!this.form.uuid) {
        this.clearData()
      }
      this.isEdit = true
    },
    // 删除配置
    delRuleEvent() {
      if (!this.form.uuid) {
        this.$message.warning(this.$t('SystemMaintenance.NoConfigurationItemsMade'))
        return
      }
      const loading = getLoading()
      const param = {
        uuid: this.form.uuid
      }
      this.rowData2 = []
      subscribePortPushRuleApi.delSubscribeConfig(param).then(resp => {
        this.$message.success(this.$t('SystemMaintenance.DeletedSuccessfully2'))
        this.cancelCustomEvent()
      }).finally(() => loading.close())
    },
    // 默认数据还原
    clearData() {
      this.form.uuid = undefined
      this.form.version = undefined
      this.form.containerLoadType = ''
      this.form.vesselVoyage = '1'
      this.form.trackingLoadingPort = 1
      this.form.loadingPortCodes = ''
      this.form.pushCondition = 1
      this.form.portDataSubscribeConfigCompanyList = []
      this.form.propertyType = 'OMS_JOB.CUSTOMER_ID'
      this.portDataSubscribeConfigCompanyList = []
      this.containerLoadTypesList = ContainerLoadType.CONTAINERLOAD_TYPES
      this.loadingPortCodesList = ['CNSHA', 'CNNGB', 'CNXMN', 'CNTAO', 'CNDCB', 'CNSHK', 'CNDLC', 'CNFOC', 'CNYTN', 'CNTXG']
      this.containerLoadTypes = ['FCL', 'LCL', 'BB', 'BC', 'BULK', 'SPA', 'BCF']
      this.synchronizationLogicSettingList = [SystemConstants.UN_BERTH_PLAN_DATE_SYN_ETD.code, SystemConstants.ESTIMATED_ARRIVAL_TIME_SYN_ETA.code]
    },
    // 保存条件
    async saveCustomEvent() {
      if (this.containerLoadTypes.length < 1) {
        this.$message.warning(this.$t('SystemMaintenance.FCLLCLTypeNotSelected'))
        return
      }
      const filter = this.portDataSubscribeConfigCompanyList.filter(item => {
        return item.type === 1
      })
      const filterBa = this.portDataSubscribeConfigCompanyList.filter(item => {
        return item.type === 2
      })
      console.log('this.form.pushCondition', this.form.pushCondition)
      console.log('this.form.pushConditionBa', this.form.pushConditionBa)
      console.log('this.portDataSubscribeConfigCompanyList', this.portDataSubscribeConfigCompanyList)
      if (this.form.pushCondition === 2 && filter.length < 1) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseSelectWhiteListCustomers'))
        return
      }
      if (this.form.pushCondition === 3 && filter.length < 1) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseSelectBlackListCustomers'))
        return
      }
      if (this.form.pushConditionBa === 2 && filterBa.length < 1) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseSelectWhiteListCustomers'))
        return
      }
      if (this.form.pushConditionBa === 3 && filterBa.length < 1) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseSelectBlackListCustomers'))
        return
      }
      if (this.rowData2) {
        // 首先去除空的
        this.rowData2 = this.rowData2.filter(item => item.branchId)
        // 再去除重复的
        this.rowData2 = Array.from(this.rowData2.reduce((map, obj) => map.set(obj.branchId, obj), new Map()).values())
      }
      const rowData2 = []
      if (this.rowData2) {
        for (const obj of this.rowData2) {
          rowData2.push(obj.branchId)
        }
      }
      if (this.form.pushCondition !== 1 || this.form.pushConditionBa !== 1) {
        this.portDataSubscribeConfigCompanyList.forEach(events => {
          let hasIn = false
          this.form.portDataSubscribeConfigCompanyList.forEach(event => {
            if (events.uuid === event.uuid && events.type === event.type) {
              hasIn = true
            }
          })
          if (!hasIn) {
            events.actionType = 1
            this.form.portDataSubscribeConfigCompanyList.push(events)
          }
        })
      }
      if (this.form.uuid) {
        // 更新
        this.form.loadingPortCodes = this.loadingPortCodesList.join(',')
        this.form.synchronizationLogicSettings = this.synchronizationLogicSettingList.join(',')
        this.form.containerLoadType = this.containerLoadTypes.join(',')
        const param = {
          uuid: this.form.uuid,
          version: this.form.version,
          containerLoadType: this.form.containerLoadType,
          vesselVoyage: this.form.vesselVoyage,
          loadingPortCodes: this.form.loadingPortCodes,
          pushCondition: this.form.pushCondition,
          pushConditionBa: this.form.pushConditionBa,
          trackingLoadingPort: this.form.trackingLoadingPort,
          portDataSubscribeConfigCompanyList: this.form.portDataSubscribeConfigCompanyList,
          cleanPolPortInfo: this.form.cleanPolPortInfo,
          synchronizationLogicSettings: this.form.synchronizationLogicSettings,
          closeOfficeList: rowData2
        }
        const loading = getLoading()
        subscribePortPushRuleApi.updateSubscribeConfig(param).then(() => {
          this.$message.success(this.$t('SystemMaintenance.SavedSuccessfully'))
          this.isEdit = false
          this.initData()
        }).finally(() => loading.close())
      } else {
        // 新增
        this.form.loadingPortCodes = this.loadingPortCodesList.join(',')
        this.form.synchronizationLogicSettings = this.synchronizationLogicSettingList.join(',')
        this.form.containerLoadType = this.containerLoadTypes.join(',')
        const param = {
          containerLoadType: this.form.containerLoadType,
          vesselVoyage: this.form.vesselVoyage,
          loadingPortCodes: this.form.loadingPortCodes,
          pushCondition: this.form.pushCondition,
          pushConditionBa: this.form.pushConditionBa,
          trackingLoadingPort: this.form.trackingLoadingPort,
          portDataSubscribeConfigCompanyList: this.form.portDataSubscribeConfigCompanyList,
          cleanPolPortInfo: this.form.cleanPolPortInfo,
          synchronizationLogicSettings: this.form.synchronizationLogicSettings,
          closeOfficeList: rowData2
        }
        const loading = getLoading()
        subscribePortPushRuleApi.addSubscribeConfig(param).then(() => {
          this.$message.success(this.$t('SystemMaintenance.SavedSuccessfully'))
          this.isEdit = false
          this.initData()
        }).finally(() => loading.close())
      }
    },
    cancelCustomEvent() {
      this.isEdit = false
      this.initData()
    },
    addCustomerEvent() {
      if (this.activeTabName === 'consignor') {
        this.title = this.$t('SystemMaintenance.PleaseSelectConsignor')
      } else if (this.activeTabName === 'bookingAgent') {
        this.title = this.$t('SystemMaintenance.PleaseSelectBookingAgent')
      }
      this.ruleViewVisible = true
    },
    addBranch() {
      this.rowData2.push({})
    },
    delBranch() {
      const selectedRows = this.gridApi2.getSelectedRows()
      if (selectedRows) {
        for (const data of selectedRows) {
          this.rowData2 = this.rowData2.filter(item => item.branchId !== data.branchId)
        }
      }
    },
    // 弹框确认按钮事件
    saveCallBackFunc(datas) {
      let type = 0
      if (this.activeTabName === 'consignor') {
        type = 1
      } else if (this.activeTabName === 'bookingAgent') {
        type = 2
      }
      const list = this.portDataSubscribeConfigCompanyList.filter(eve => eve.type === type)
      list.forEach(eve => {
        datas = datas.filter(item => item.cmpIdx !== eve.cmpIdx)
      })
      for (const c1 of datas) {
        c1.selected = false
        this.portDataSubscribeConfigCompanyList.push({
          uuid: c1.uuid,
          cmpIdx: c1.cmpIdx,
          branchId: c1.branchId,
          branchName: ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', c1.branchId, 'code'),
          chineseName: c1.chineseName || '',
          cmpName: c1.chineseName || '',
          cnShortName: c1.cnShortName || '',
          englishName: c1.englishName || '',
          type: type
        })
      }
      this.sortCmp()
    },
    // 删除客户
    delCustomEvent() {
      if (this.portDataSubscribeConfigCompanyList != null && this.portDataSubscribeConfigCompanyList.length > 0) {
        const selections = getGridSelected(this.gridOptions)
        let uuidList = []
        if (selections && selections.length > 0) {
          selections.forEach(row => {
            const index = this.portDataSubscribeConfigCompanyList.findIndex(c => c.uuid === row.uuid)
            uuidList = Array.from(this.portDataSubscribeConfigCompanyList.filter(c => c.uuid === row.uuid), c => c.uuid)
            if (index > -1) {
              this.portDataSubscribeConfigCompanyList.splice(index, 1)
            }
          })
          uuidList.forEach(eve => {
            this.form.portDataSubscribeConfigCompanyList.forEach((e, index) => {
              if (eve === e.uuid) {
                e.actionType = 2
              }
            })
          })
        } else {
          this.$message.warning('请选择至少一条数据进行删除！')
        }
      }
      this.sortCmp()
    },
    applyFilter() {
      console.log('this.portDataSubscribeConfigCompanyList', this.portDataSubscribeConfigCompanyList)
      if (this.portDataSubscribeConfigCompanyList != null && this.portDataSubscribeConfigCompanyList.length > 0) {
        // 过滤符合条件的数据
        let rowData = []
        if (this.activeTabName === 'consignor') {
          rowData = this.portDataSubscribeConfigCompanyList.filter(item => {
            return item.type === 1
          })
        } else if (this.activeTabName === 'bookingAgent') {
          rowData = this.portDataSubscribeConfigCompanyList.filter(item => {
            return item.type === 2
          })
        }
        // 中英首字母混排
        this.rowData = rowData.sort((a, b) => {
          const x = a.chineseName ? a.chineseName[0] : ''
          const y = b.chineseName ? b.chineseName[0] : ''
          const reg = /[a-zA-Z0-9]/
          if (reg.test(x) || reg.test(y)) {
            if (x > y) {
              return 1
            } else if (x < y) {
              return -1
            } else {
              return 0
            }
          } else {
            return x.localeCompare(y)
          }
        })
      } else {
        this.rowData = []
      }
    },
    // 整拼类型修改事件
    cargoTypeChange(val) {
      this.$refs.containerLoadType.convertSelectedToText()
      this.containerLoadTypes = val.value
    },
    handleChange(val) {
      if (val === 1) {
        if (this.activeTabName === 'consignor') {
          this.portDataSubscribeConfigCompanyList = this.portDataSubscribeConfigCompanyList.filter(item => {
            return item.type === 2
          })
        }
        if (this.activeTabName === 'bookingAgent') {
          this.portDataSubscribeConfigCompanyList = this.portDataSubscribeConfigCompanyList.filter(item => {
            return item.type === 1
          })
        }
        this.form.portDataSubscribeConfigCompanyList.forEach(eve => {
          if ((this.activeTabName === 'consignor' && eve.type === 1) || (this.activeTabName === 'bookingAgent' && eve.type === 2)) {
            eve.actionType = 2
          }
        })
      }
    },
    // 下载港口服务范围
    onDownloadTemplate() {
      ExportUtils.downloadTemplateFile('查看港口支持范围.xlsx', 'booking')
    },
    handleCheckboxChange(value) {
      this.form.cleanPolPortInfo = value
    }
  }
}
</script>

<style lang="scss" scoped>
.form-column{
  background-color: #f0f3f8;
  padding: 10px 20px 20px;
  margin: 0;
  .el-form{
    padding-left: 20px;
    .el-select{
      width: 300px !important;
    }
  }
  > p{
    margin: 5px 20px 0 0;
    text-align: right;
    color: #409eff;
    cursor: pointer;
    user-select: none;
    display: block;
  }
  .title{
    line-height: 22px;
    font-size: 14px;
    padding-bottom: 8px;
    font-weight: bold;
    display: block;
    i{
      margin-left: 5px;
      font-size: 14px;
    }
  }
  .form-config-more{
    margin-top: 5px;
    .el-form{
      padding-left: 20px;
      /deep/ .el-radio__label{
        font-size: 12px;
      }
    }
    .el-checkbox-group{
      line-height: 28px;
      margin-left: 20px;
      label{
        &:first-of-type{
          width: 100px;
          font-weight: normal;
          display: inline-block;
        }
        &.el-checkbox{
          margin: 0 20px 0 0;
          /deep/ .el-checkbox__label{
            padding-left: 5px;
          }
        }
      }
    }
  }
}
.grid-wrapper{
  margin-top: 5px;
  background-color: #f0f3f8;
  padding: 5px;
  flex-direction: column;
  .screen-btn{
    display: block;
    margin: 5px 0 10px 30px;
    .el-button{
      margin-right: 10px;
    }
  }
}
.title{
  line-height: 22px;
  font-size: 14px;
  padding-bottom: 8px;
  font-weight: bold;
  display: block;
  i{
    margin-left: 5px;
    font-size: 14px;
  }
}
.sync-checkbox {
  margin-right: 50px !important;

  &:last-child {
    margin-right: 0;
  }
}
</style>
